import { UserRole } from '@app/domain/AccountUser'
import { BillingDetails } from '@app/domain/BillingDetails'
import { NumberPublisher } from '@app/domain/NumberPublisher'
import { Venue } from '@app/domain/Venue'

export class MenuItem {
    hidden = true

    constructor(
        public title: string,
        public icon: string,
        public route: string,
        public showNotificationCount: boolean = false,
        public notificationCountPublisher: NumberPublisher | null = null,
        private hideConditionFunc?: ((billingDetails: BillingDetails, venue: Venue) => boolean),
        public requiredRole?: UserRole,
    ) { }

    configure(
        billingDetails: BillingDetails,
        venue: Venue
    ) {
        const hide = this.hideConditionFunc
        if (hide === undefined) {
            this.hidden = false
            return
        }
        this.hidden = hide(billingDetails, venue)
    }
}
